<template>
    <div>
        <clients />

        <upcoming-birthdays />

        <upcoming-anniversaries />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Clients from '@/views/Partials/Clients'
    import UpcomingBirthdays from '@/views/Partials/UpcomingBirthdays'
    import UpcomingAnniversaries from '@/views/Partials/UpcomingAnniversaries'

    export default {
        components: {
            'clients': Clients,
            'upcoming-birthdays': UpcomingBirthdays,
            'upcoming-anniversaries': UpcomingAnniversaries
        },
    }
</script>
